import React from 'react';
import { Input, Button, Space, Card } from 'antd';
import { SearchOutlined, ClearOutlined } from '@ant-design/icons';

interface QueryParamsProps {
  codeFrom: string;
  codeTo: string;
  loading: boolean;
  onCodeFromChange: (value: string) => void;
  onCodeToChange: (value: string) => void;
  onQuery: () => void;
  onReset: () => void;
}

const QueryParamsPanel: React.FC<QueryParamsProps> = ({
  codeFrom, codeTo, loading,
  onCodeFromChange, onCodeToChange, onQuery, onReset,
}) => {
  return (
    <Card size="small" style={{ marginBottom: 16 }}>
      <Space wrap size="middle" style={{ width: '100%' }}>
        <div>
          <label style={{ display: 'block', fontSize: 12, color: '#666', marginBottom: 4 }}>工繳代號起</label>
          <Input value={codeFrom} onChange={(e) => onCodeFromChange(e.target.value)} placeholder="起始代號" style={{ width: 150 }} allowClear />
        </div>
        <div>
          <label style={{ display: 'block', fontSize: 12, color: '#666', marginBottom: 4 }}>工繳代號迄</label>
          <Input value={codeTo} onChange={(e) => onCodeToChange(e.target.value)} placeholder="結束代號" style={{ width: 150 }} allowClear />
        </div>
        <div style={{ display: 'flex', alignItems: 'flex-end', paddingTop: 18 }}>
          <Space>
            <Button type="primary" icon={<SearchOutlined />} onClick={onQuery} loading={loading}>查詢</Button>
            <Button icon={<ClearOutlined />} onClick={onReset}>清除</Button>
          </Space>
        </div>
      </Space>
    </Card>
  );
};

export default QueryParamsPanel;
